import {
  Filter,
  UserX,
  FileEdit,
  ShieldCheck,
  Lock,
  Mail,
  Share2,
  PhoneCall,
  Contact,
  TrendingUp,
  Megaphone,
  Target,
  ShieldAlert,
} from "lucide-react";

export const APPENDING_SERVICES = [
  {
    title: "Email Data Appending",
    desc: "Fill in missing corporate email addresses with direct, deliverable inboxes verified via SMTP handshakes.",
    icon: Mail,
  },
  {
    title: "Social Profile Appending",
    desc: "Enrich executive contact profiles with validated LinkedIn handles and professional social footprints.",
    icon: Share2,
  },
  {
    title: "Phone Appending",
    desc: "Update records with verified direct dials, corporate headquarters desk lines, and cell phone extensions.",
    icon: PhoneCall,
  },
  {
    title: "Full Contact Appending",
    desc: "Complete 360° record revitalization: firmographics, postal address, hierarchy title, email, and phone.",
    icon: Contact,
  },
];

export const DATA_ADDITION_CYCLE = [
  {
    id: "segmentation",
    step: "01",
    title: "Data Segmentation",
    icon: Filter,
    desc: "The data is filtered based on the requirements to build and maintain relevant customers. The segmentation of your data helps to build up a communicative channel directly to your customer base through targeted messaging. Not only does it allow you to analyse your current customer base it also segments your incoming data.",
  },
  {
    id: "erase",
    step: "02",
    title: "Clear Unresponsive Data",
    icon: UserX,
    desc: "Any unresponsive data will be permanently removed from your records. This ensures that your marketing strategy is only directed at the target audience that is accessible and interested in your line of service. Reaching a target audience that is not part of your target customer base not only means a waste of your efforts but also decreases your production.",
  },
  {
    id: "update",
    step: "03",
    title: "Update Missing Sections",
    icon: FileEdit,
    desc: "Once unresponsive data has been removed from your records, it's now easier to update missing information in your existing database. An up-to-date database promotes your marketing strategy with users who intend to buy.",
  },
  {
    id: "verification",
    step: "04",
    title: "Data Verification",
    icon: ShieldCheck,
    desc: "To ensure that the data you receive is valid and authentic, data scientists and verification team process it manually. We believe in quality and do everything we can to make sure your contact list reflects that.",
  },
  {
    id: "authentication",
    step: "05",
    title: "Final Authentication",
    icon: Lock,
    desc: "In the final phase, we ensure that the data is authenticated in order to avoid data breaches. Our data carry heavy legal responsibility and protect the misuse and exploitation of data.",
  },
];

export const EMAIL_AGGREGATION_ADVANTAGES = [
  {
    icon: Target,
    title: "Choose Executives with Faster Conversion",
    desc: "Direct access to authoritative decision-makers with buying capacity accelerates deal velocity.",
  },
  {
    icon: Megaphone,
    title: "Create Brand Awareness Through Effective Campaigns",
    desc: "Deliver personalized outreach to accurate inboxes without risking domain spam flags.",
  },
  {
    icon: TrendingUp,
    title: "Generate High-Quality Leads with Higher ROI",
    desc: "Transform dormant customer files into high-yield pipeline assets with verified records.",
  },
  {
    icon: ShieldAlert,
    title: "Reinforce Operational Communication",
    desc: "Strengthen company commitments with clean, responsive, and policy-compliant pipelines.",
  },
];

export const HIGHLIGHT_PILLARS = [
  "Data segmentation",
  "Erase unresponsive data",
  "Update missing fields",
  "Data Verification",
  "Final Authentication",
];